import { Box, Typography } from '@mui/material';
import { buildConsumptionBar } from './consumptionSlots';

/**
 * A partir de este número de huecos la separación baja a 1px: con 2px la
 * separación se comía casi un tercio del hueco y la barra se leía como rayas.
 */
const DENSE_SLOT_THRESHOLD = 30;

/**
 * Los tokens del sistema (ver `--usage-*` en src/index.css): 3,32:1 entre
 * hueco libre y hueco gastado. El gastado es casi blanco a propósito —es un
 * hueco vacío—, así que quien delimita la barra es el borde.
 */
const CONSUMED_COLOR = 'var(--usage-spent)';
const AVAILABLE_COLOR = 'var(--usage-free)';
const BAR_EDGE_COLOR = 'var(--border)';

type ConsumptionProps = {
    caption: string;
    amount: number;
    consumed: number;
};

export default function Consumption({
    caption,
    amount,
    consumed,
}: ConsumptionProps) {
    const bar = buildConsumptionBar(amount, consumed);
    const isDense =
        bar.mode === 'segmented' && bar.slots.length > DENSE_SLOT_THRESHOLD;

    return (
        <div style={{ width: '100%' }}>
            {caption && (
                <Box mb={1}>
                    <Typography variant="body2">{caption}</Typography>
                </Box>
            )}
            <Box
                sx={{
                    width: '100%',
                    height: 24,
                    display: 'flex',
                    alignItems: 'stretch',
                    flexDirection: 'row',
                    gap: bar.mode === 'segmented' ? `${isDense ? 1 : 2}px` : 0,
                    border: '1px solid',
                    borderColor: BAR_EDGE_COLOR,
                    borderRadius: 0.5,
                    overflow: 'hidden',
                }}
            >
                {bar.mode === 'segmented'
                    ? bar.slots.map((slot, index) => (
                          <Box
                              key={`slot-${index}`}
                              sx={{
                                  flex: 1,
                                  backgroundColor:
                                      slot === 'consumed'
                                          ? CONSUMED_COLOR
                                          : AVAILABLE_COLOR,
                              }}
                          />
                      ))
                    : [
                          <Box
                              key="consumed"
                              sx={{
                                  width: `${bar.consumedRatio * 100}%`,
                                  backgroundColor: CONSUMED_COLOR,
                              }}
                          />,
                          <Box
                              key="available"
                              sx={{
                                  flex: 1,
                                  backgroundColor: AVAILABLE_COLOR,
                              }}
                          />,
                      ]}
            </Box>
        </div>
    );
}
